export default __webpack_public_path__ + "static/core_back-c49eaf2b7de8ea9de25f2064d1c7555b.webp";